<template>
    <div class="popup account-dialog account-dialog--bank-form account-dialog--clabe">
        <van-popup :value="show" @click-overlay="close">
            <div class="content">
                <statusBar></statusBar>
                <div class="header">
                    <div>{{ $t("Withdraw.Add") + ' CLABE' }}</div>
                    <div class="close"><AccountUiIcon name="close" @click.native="close" /></div>
                </div>
                <div class="info_box">
                    <a-form-model ref="ruleForm" :model="formData" :rules="rules" @submit.native.prevent>
                        <a-form-model-item ref="customerName" label="" prop="customerName">
                            <div class="account-field-label">{{ $t('bankset.AccountName') }}</div>
                            <a-input v-model="formData.customerName" :placeholder="$t('bankset.InputAccountName')" />
                        </a-form-model-item>
                        <a-form-model-item label="" prop="customerEmail">
                            <div class="account-field-label">{{ $t('bankset.email') }}</div>
                            <a-input v-model="formData.customerEmail" :placeholder="$t('bankset.PleaseEnterEmail')" />
                        </a-form-model-item>
                        <a-form-model-item label="" prop="bankName">
                            <div class="account-field-label">{{ $t('bankset.ChooseBank') }}</div>
                            <div class="bank-select-field">
                                <a-input v-model="formData.bankName" disabled :placeholder="$t('bankset.ChooseBank')" />
                                <div class="bank-select-trigger" @click="onShowChannelPopup"><AccountUiIcon name="down" /></div>
                            </div>
                        </a-form-model-item>
                        <a-form-model-item label="" prop="customerAccountNumber">
                            <div class="account-field-label">{{ $t('bankset.PayeeAccount') + ' CLABE' }}</div>
                            <a-input v-model="formData.customerAccountNumber" :placeholder="$t('bankset.InputPayeeAccount')" />
                        </a-form-model-item>
                    </a-form-model>
                </div>
                <div class="tips"><AccountUiIcon name="info" /><span>{{ $t('bankset.banksetPopupTips3') }}</span></div>
                <div class="action_btn" @click="formSubmit"><span>{{ $t("lang.confirm") }}</span></div>
            </div>
        </van-popup>
        <channelPopup ref="channelPopup" :name="formData.bankName" @onConfirm="onChannelPopupConfirm"></channelPopup>
    </div>
</template>

<script>
import AccountUiIcon from '@/components/account-dialogs/AccountUiIcon.vue'
import statusBar from '@/components/statusBar'
import { saveBankMexico, updateBankMexico } from '@/api/withdraw'
import { Toast } from 'vant'
import md5 from 'md5'
import { deepClone } from '@/utils'
import channelPopup from './channelPopup.vue'
export default {
    name: 'changePwd',
    components: { AccountUiIcon, statusBar, channelPopup },
    data() {
        return {
            show: false,
            isFocus: 0,
            formData: {
                customerType: 'CLABE',
                customerName: '',
                customerEmail: '',
                bankName: '',
                customerAccountNumber: '',
                // accountTax: '',
                withdrawPassword: '',
                withdrawPasswordVerify: ''
            },
            rules: {},
            isShowBankList: false,
            canCallHandleWithDraw: true
        }
    },
    methods: {
        open() {
            const that = this
            const withdrawPwdForm = that.$store.getters.withdrawPwdForm
            if (withdrawPwdForm) {
                const pwdForm = JSON.parse(decodeURIComponent(withdrawPwdForm))
                that.formData.withdrawPassword = pwdForm.pwd1
                that.formData.withdrawPasswordVerify = pwdForm.pwd2
            }
            this.show = true
        },
        close() {
            this.formData = {
                customerType: 'CLABE',
                customerName: '',
                customerEmail: '',
                bankName: '',
                customerAccountNumber: '',
                // accountTax: '',
                withdrawPassword: '',
                withdrawPasswordVerify: ''
            }
            this.show = false
        },
        formSubmit() {
            const that = this
            const formdata = that.formData
            that.$refs.ruleForm.validate(async (valid) => {
                if (valid) {
                    if (that.canCallHandleWithDraw) {
                        if (!formdata.customerName) {
                            Toast(this.$t('bankset.InputAccountName'))
                            return
                        }
                        if (!formdata.customerEmail) {
                            Toast(this.$t('bankset.PleaseEnterEmail'))
                            return
                        }
                        const emailReg = /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/
                        if (!emailReg.test(formdata.customerEmail)) {
                            Toast(this.$t('login.PleaseEnterEmailFormat'))
                            return
                        }
                        if (!formdata.bankName) {
                            Toast(this.$t('bankset.PleaseSelectBank'))
                            return
                        }
                        if (!formdata.customerAccountNumber) {
                            Toast(this.$t('bankset.PayeeAccountTips3'))
                            return
                        }
                        const numReg = /^\d{18}$/
                        if (!numReg.test(formdata.customerAccountNumber)) {
                            Toast(this.$t('bankset.PayeeAccountTips3'))
                            return
                        }
                        // if (!formdata.accountTax) {
                        //     Toast(this.$t('bankset.PleaseEnterTaxID'))
                        //     return
                        // }
                        // const taxReg = /^.{12,13}$/
                        // if (!taxReg.test(formdata.accountTax)) {
                        //     Toast(this.$t('bankset.TaxIDTips'))
                        //     return
                        // }
                        that.canCallHandleWithDraw = false
                        const form = deepClone(formdata)
                        form.accountName = form.pixAccount
                        if (form.withdrawPassword) form.withdrawPassword = md5(form.withdrawPassword)
                        if (form.withdrawPasswordVerify) form.withdrawPasswordVerify = md5(form.withdrawPasswordVerify)
                        let result
                        if (form.id) {
                            result = await updateBankMexico(form)
                        } else {
                            result = await saveBankMexico(form)
                        }
                        that.canCallHandleWithDraw = true
                        Toast(result.message)
                        if (result.code) return
                        that.$emit('setBankSucc')
                        that.close()
                    }
                }
            })
        },
        onShowChannelPopup() {
            console.log(888)
            this.$refs.channelPopup.open()
        },
        onChannelPopupConfirm(e) {
            this.formData.bankName = e
            this.$forceUpdate()
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/account-dialogs.scss';
</style>
